/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetRegisteredPasskeysQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRegisteredPasskeysQuery = (
  { __typename?: 'Query' }
  & { getRegisteredPasskeys: (
    { __typename?: 'GetRegisteredPasskeys' }
    & { passkeys: Array<(
      { __typename?: 'Passkey' }
      & Pick<Types.Passkey, 'id' | 'nickname' | 'created' | 'lastTimeUsed'>
    )> }
  ) }
);


export const GetRegisteredPasskeysDocument = gql`
    query GetRegisteredPasskeys {
  getRegisteredPasskeys {
    passkeys {
      id
      nickname
      created
      lastTimeUsed
    }
  }
}
    `;

/**
 * __useGetRegisteredPasskeysQuery__
 *
 * To run a query within a React component, call `useGetRegisteredPasskeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegisteredPasskeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegisteredPasskeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegisteredPasskeysQuery(baseOptions?: Apollo.QueryHookOptions<GetRegisteredPasskeysQuery, GetRegisteredPasskeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegisteredPasskeysQuery, GetRegisteredPasskeysQueryVariables>(GetRegisteredPasskeysDocument, options);
      }
export function useGetRegisteredPasskeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegisteredPasskeysQuery, GetRegisteredPasskeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegisteredPasskeysQuery, GetRegisteredPasskeysQueryVariables>(GetRegisteredPasskeysDocument, options);
        }
export type GetRegisteredPasskeysQueryHookResult = ReturnType<typeof useGetRegisteredPasskeysQuery>;
export type GetRegisteredPasskeysLazyQueryHookResult = ReturnType<typeof useGetRegisteredPasskeysLazyQuery>;
export type GetRegisteredPasskeysQueryResult = Apollo.QueryResult<GetRegisteredPasskeysQuery, GetRegisteredPasskeysQueryVariables>;